import {useEffect, useContext } from 'react';
import axios from 'axios';
import { useAuth } from '../Authentification/Auth';
import { IdBCContext } from '../IdBCContext';
import API_BASE_URL from './config';

const AppelAPIAlimentaire = ({compteurAlim,setLancer, Lancer, save, setApiResponse, setAppelAlimentaire,  filledData, usedUrl, lancerSave, setLancerSave}) => {
  const { token, isTokenExpired } = useAuth();
  const { idBC } = useContext(IdBCContext);

  useEffect(() => {
    isTokenExpired()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    // Vérifier si le token est disponible avant de faire la requête
    if (token && Lancer) { 
       fetchData();
     }
  }, [token, Lancer]); // Se ré-exécute lorsque `token` change

  useEffect(() => {
    // Vérifier si le token est disponible avant de faire la requête
    if(token && lancerSave){
       fetchDataToSave(filledData, usedUrl);
       setLancerSave(false)
     }
  }, [token, lancerSave]); // Se ré-exécute lorsque `token` change


  const fetchDataToSave = async (filledData, usedUrl) => {
    ;
    filledData.save = true
    
    const options = {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    };
    
    try {
      const result = await axios.post(usedUrl, filledData, options);

    } catch (error) {
      console.error("Erreur lors de l'envoi de la requête :", error);
      

    } finally {
      
      setLancerSave(false)    
    }
  }

   const fetchData = async () => {
     ;
    const apiUrl = `${API_BASE_URL}/aps_Palimentaire_Global`;
    
    const data = {
      IdBC: idBC,
      IdPage: "PAlimentaire",
      cerealier: compteurAlim.cerealier,
      continental: compteurAlim.continental,
      sale: compteurAlim.sale,
      vegetarien: compteurAlim.vegetarien,
      vegetalien: compteurAlim.vegetalien,
      produitsMarins: compteurAlim.produitsMarins,
      viandeBovine: compteurAlim.viandeBovine,
      viandeVolaille: compteurAlim.viandeVolaille,
      viandeRougePlus: compteurAlim.viandeRougePlus,
      viandeRougeEntre: compteurAlim.viandeRougeEntre,
      viandeRougeMoins: compteurAlim.viandeRougeMoins,
      viandeBlanchePlus: compteurAlim.viandeBlanchePlus,
      viandeBlancheEntre: compteurAlim.viandeBlancheEntre,
      viandeBlancheMoins:compteurAlim.viandeBlancheMoins,
      cafe:compteurAlim.cafe,
      the:compteurAlim.the,
      jusFruits:compteurAlim.jusFruits,
      soda:compteurAlim.soda,
      alcool:compteurAlim.alcool,
      save: save
    };

    const options = {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    };

    try {
      const resultAlim = await axios.post(apiUrl, data, options);
      // Stocker à jour l'appel à l'API pour plus tard
      setAppelAlimentaire(0, data, apiUrl)
       // Mettre à jour la réponse de l'API dans le composant parent
       setApiResponse(resultAlim.data);
       setLancer(false);

    } catch (error) {
      console.error("Erreur lors de l'envoi de la requête :", error);
      
    } finally {
      
    }
  };
  return (null);
};

export default AppelAPIAlimentaire;
